import { signInWithMetaMask } from "@flare.space/ftso-web3";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";

declare global {
  interface Window {
    ethereum?: any;
  }
}

interface MetamaskService {
  onAccountsChanged: any;
  onChainChanged: any;
  onDisconnect: any;
  connectWithMetaMask: (callback?: (account: string) => void) => void;
  connectAnotherAccount: (callback?: () => void) => void;
}

const MetamaskService: MetamaskService = {
  onAccountsChanged: null,
  onChainChanged: null,
  onDisconnect: null,

  connectWithMetaMask: (callback?: (account: string) => void) => {
    signInWithMetaMask()
      .pipe(
        catchError((err) => {
          console.error(err);
          return of(null);
        })
      )
      .subscribe((account) => {
        if (account && callback) {
          callback(account as string);
        }
      });
  },
  connectAnotherAccount: (callback?: (account: string) => void) => {
    window.ethereum
      .request({
        method: "wallet_requestPermissions",
        params: [{ eth_accounts: {} }],
      })
      .then(() => {
        window.ethereum
          .request({
            method: "eth_requestAccounts",
            params: [{ eth_accounts: {} }],
          })
          .then((accounts: string[]) => {
            if (callback) {
              callback(accounts[0]);
            }
          });
      });
  },
};

export default MetamaskService;
